import Swal from "sweetalert2";

export default function Message({ message, type }) {
    Swal.fire({
        text: message,
        icon: type,
        confirmButtonColor: "var(--color-orange)",
        confirmButtonText: "Aceptar",
    })
}